module.exports = __webpack_public_path__ + "images/cdfa78ee4fde901e8c8a17d860456e17.png";